import { Component, Element, h, Prop } from '@stencil/core';
import fitText from '../../../../../library/fittext.js';

@Component({
  tag: 'presto-dynamic-overlay-ui',
  styleUrl: 'presto-dynamic-overlay-ui.scss',
  shadow: true,
})
export class PrestoDynamicOverlayUi {
  @Element() el: HTMLElement;

  private text: HTMLAnchorElement;

  /** When set, the underlying button will be rendered as an `<a>` with this `href` instead of a `<button>`. */
  @Prop() href: string;

  /** Tells the browser where to open the link. Only used when `href` is set. */
  @Prop() target: '_blank' | '_parent' | '_self' | '_top';

  @Prop() position: 'top-left' | 'top-right' = 'top-right';

  closestElement(selector, el) {
    return (el && el != document && el != window && el.closest(selector)) || (el && this.closestElement(selector, el.getRootNode().host));
  }

  componentDidLoad() {
    let player = this.closestElement('presto-player', this.el) as HTMLPrestoPlayerElement;
    fitText(this.text, 3, {
      maxFontSize: 16,
      minFontSize: 10,
      container: player,
    });
  }

  render() {
    const Tag = this.href ? 'a' : ('span' as keyof JSX.IntrinsicElements);
    return (
      <Tag
        class={{
          'overlay-text': true,
          'overlay--top-left': this.position === 'top-left',
          'overlay--top-right': this.position === 'top-right',
        }}
        href={this.href}
        target={this.target}
        part="overlay-text"
        ref={el => (this.text = el as HTMLAnchorElement)}
      >
        <slot />
      </Tag>
    );
  }
}
